/****************************************************
 * Module Name:  OfferModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import { Box, Button, TextField, InputAdornment, Tooltip, Typography, } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import "../../style/modalstyle.css";
import { useEffect } from "react";
import { DataGridPro, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import StoneProxy from "../../utility/proxy/manager/stoneProxy";
import StoneDetailModal from "../common/stoneDetailModal";
import { FaFileInvoice } from "react-icons/fa";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg';
import UtilityProxy from "../../utility/proxy/manager/utilityProxy";
import EditIcon from '@mui/icons-material/Edit';
import BrokerProxy from "../../utility/proxy/manager/brokerProxy";
import Select from "react-select";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "./userDetailModal";
import UserProxy from "../../utility/proxy/manager/userProxy";
import CheckIcon from '@mui/icons-material/Check';

const OfferModal = ({
  show,
  setShow,
  handleValidation,
  handleOffer,
  stoneId,
  customer,
  user,
  loadingOfferButton,
  notPermitted,
}) => {
  const { apiRef, handleCellClick } = Utility.useSingleClickEdit();
  const defaultBroker = { brokerid: -1, username: "", value: -1, label: " - " };
  const [stonesLoader, setStonesLoader] = useState(false);
  const [listData, setListData] = useState([]);
  const [showError, setShowError] = useState(false);
  const [totalCarat, setTotalCarat] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [actualAmount, setActualAmount] = useState(0);
  const [invoiceAmount, setInvoiceAmount] = useState(0);
  const [avgPricePerCarats, setAvgPricePerCarats] = useState(0);
  const [payableAmount, setPayableAmount] = useState(0);
  const [remark, setRemark] = useState("");
  const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);
  const [stoneDetailModalId, setStoneDetailModalId] = useState("");
  const [date, setDate] = useState("");
  const [oldInvoiceAmount, setOldInvoiceAmount] = useState(0);

  const [newTotalDiscount, setNewTotalDiscount] = useState(0);
  const [newTotalPPC, setNewTotalPPC] = useState(0);
  const [newTotalInvoiceAmount, setNewTotalInvoiceAmount] = useState(0);
  const [columnNames, setColumnNames] = React.useState([]);
  const [offerButtonDisable, setOfferButtonDisable] = useState(false);

  const [broker, setBroker] = useState(defaultBroker);
  const [brokerOptions, setBrokerOptions] = useState([]);
  const [showUserDetailModal, setShowUserDetailModal] = useState(false);
  const [oldDays, setOldDays] = useState(0);
  const [days, setDays] = useState(0);
  const [daysloss, setDaysloss] = useState(0);
  const [brokerCommissionPercent, setBrokerCommissionPercent] = useState(0);
  const [addLessPercent, setAddLessPercent] = useState(0);
  const [oldAddLessPercent, setOldAddLessPercent] = useState(0);
  const [addLessAmount, setAddLessAmount] = useState(0);
  const [oldAddLessAmount, setOldAddLessAmount] = useState(0);
  const [brokerCommission, setBrokerCommission] = useState(0);
  const [stonetype, setStonetype] = useState();
  const [applyValue, setApplyValue] = useState(0);
  const [applyToAll, setApplyToAll] = useState("");
  const applyToAllOption = [
    { value: 1, label: "Discount" },
    { value: 2, label: "PPC" },
    { value: 3, label: "Total" },
  ]

  const offer_Permission = Constants.USER_PERMISSION.filter((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.DIRECTOFFER);

  useEffect(() => {
    handleSearch(stoneId);
    getAllCustomerBroker();
    setApplyToAll(!applyToAll ? applyToAllOption[0] : applyToAll);
  }, []);

  const getAllCustomerBroker = () => {
    if (Constants.loggedInUser.usertype !== "B") {
      BrokerProxy.getCustomersBrokerMini(customer.value, (response) => {
        if (response) {
          let optionsArray = [];
          response.forEach(iBroker => {
            let options = { value: iBroker.brokerid, label: iBroker.brokerid + " | " + iBroker.companyname, brokerid: iBroker.brokerid, username: iBroker.companyname };
            optionsArray.push(options);
          });
          setBrokerOptions(optionsArray);
          setBroker(optionsArray.length > 0 ? optionsArray[0] : defaultBroker);
        }
      })
    } else {
      setBroker({ value: Constants.loggedInUser.id, label: Constants.loggedInUser.id + " | " + Constants.loggedInUser.companyname, brokerid: Constants.loggedInUser.id, username: Constants.loggedInUser.companyname });
    }
  }

  useEffect(() => {
    if (!broker || broker.brokerid === -1 || stonetype === undefined) {
      setBrokerCommissionPercent(0);
      setBrokerCommission(0);
    } else {
      UserProxy.GetBrokerCommissionByStonetype(broker.brokerid, stonetype, (response) => {
        if (response) {
          setBrokerCommissionPercent(response.brokercommission);
          setBrokerCommission(response.brokercommission ? Number((invoiceAmount * (response.brokercommission / 100)).toFixed(2)) : 0);
        }
      });
    }
  }, [broker, stonetype]);

  useEffect(() => {
    let newInvoiceAmount = addLessAmount ? Number(invoiceAmount) + Number(addLessAmount) : invoiceAmount;
    let lossPercentage = Number((oldDays / 30).toFixed(2));
    setDaysloss(Number((newInvoiceAmount * (lossPercentage / 100)).toFixed(2)));
  }, [oldDays]);

  useEffect(() => {
    let newInvoiceAmount = addLessAmount ? Number(invoiceAmount) + Number(addLessAmount) : invoiceAmount;
    let lossPercentage = Number((oldDays / 30).toFixed(2));
    let daysloss = Number((newInvoiceAmount * (lossPercentage / 100)).toFixed(2));
    let brokerCommission = brokerCommissionPercent ? Number((newInvoiceAmount * (brokerCommissionPercent / 100)).toFixed(2)) : 0;
    setDaysloss(daysloss);
    setBrokerCommission(brokerCommission);
    setPayableAmount((Number(newInvoiceAmount) - Number(daysloss) - Number(brokerCommission)).toFixed(2));
  }, [invoiceAmount, brokerCommission, daysloss, addLessAmount]);

  const handleSearch = (stoneId) => {
    setStonesLoader(true);
    let flag = false;
    StoneProxy.GetMultipleStone(customer.value, stoneId, (response) => {
      prepareColumns();
      let lTotalCarat = 0;
      let lActualPrice = 0;
      let newListData = [];
      let lInvoiceAmount = 0;
      response.map((res) => {
        if (!flag) {
          if (res.stonetype === "N") {
            setStonetype(true);
          } else {
            setStonetype(false);
          }
          flag = true;
        }
        lTotalCarat += Number(res.size);
        lActualPrice += Number(res.size * res.originalprice);
        let actualPrice = Number(res.originalprice * res.size);
        let discPrice = Number(actualPrice * ((100 + res.discount) / 100));
        let listOp = {
          ...res,
          discountprice: discPrice,
          editedprice: (Number(discPrice) / Number(res.size)).toFixed(2),
          editeddiscount: res.discount,
          editedtotal: discPrice,
          isDiscountEditable: res.colortype === "WHITE" ? Boolean(true) : Boolean(false),
          olddiscount: res.discount,
          olddiscountprice: discPrice,
          oldppc: (Number(discPrice) / Number(res.size)).toFixed(2),
        };
        newListData.push(listOp);
        lInvoiceAmount += Number(actualPrice * ((100 + res.discount) / 100));
        return true;
      });

      let tempInvoiceAmount = Number(lInvoiceAmount.toFixed(2));
      let tempPricePerAmount = Number((lInvoiceAmount / lTotalCarat).toFixed(2));
      let tempDiscount = Number(((100 - (lInvoiceAmount * 100) / lActualPrice) * -1).toFixed(2));
      let brokerCommission = brokerCommissionPercent ? Number((tempInvoiceAmount * (brokerCommissionPercent / 100)).toFixed(2)) : 0;

      setOldInvoiceAmount(lInvoiceAmount.toFixed(2));
      setStonesLoader(false);
      setTotalCarat(lTotalCarat.toFixed(2));
      setActualAmount(lActualPrice.toFixed(2));
      setListData(newListData);
      setTotalDiscount(tempDiscount);
      setInvoiceAmount(tempInvoiceAmount);
      setAvgPricePerCarats(tempPricePerAmount);
      setPayableAmount(tempInvoiceAmount - Number(brokerCommission));
      setNewTotalDiscount(tempDiscount);
      setNewTotalPPC(tempPricePerAmount);
      setNewTotalInvoiceAmount(tempInvoiceAmount);
      setAddLessAmount(0);
      setAddLessPercent(0);
      setDays(0);
      setOldDays(0);
      setDaysloss(0);
      setApplyValue(0);
    });

    const prepareColumns = () => {
      let columnNames = [];

      Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
        if (columnsData.hasOwnProperty(iColPermission)) {
          const columnData = columnsData[iColPermission];
          columnNames.push(columnData);
          if (columnData.field === "discount") {
            columnNames.push({
              field: "editeddiscount",
              headerName: "OFFER DISCOUNT",
              headerAlign: "center",
              align: "center",
              width: 124,
              renderCell: (params) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: '8px' }}>{Utility.ConvertNumberWithSpecifiedDigits(params.row.editeddiscount)}</span>
                  {params.colDef.editable && <EditIcon style={{ marginLeft: 10, marginBottom: 3, fontSize: '1rem', marginRight: -16 }} />}
                </div>
              ),
              editable: (params) => params.row.isDiscountEditable,
              cellClassName: (params) => 'lavenderCell',
            })
          }
          else if (columnData.field === "discountpricepercarat") {
            columnNames.push({
              field: "editedprice",
              headerName: "OFFER P/CT",
              headerAlign: "center",
              align: "center",
              width: 115,
              editable: !notPermitted,
              renderCell: (params) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: '8px' }}>{params.value}</span>
                  {params.colDef.editable && <EditIcon style={{ marginLeft: 10, marginBottom: 3, fontSize: '1rem', marginRight: -16 }} />}
                </div>
              ),
              valueGetter: (params) =>
                (Number(params.row.editedtotal) / Number(params.row.size)).toFixed(2),
              cellClassName: (params) => 'lavenderCell',
            })
          }
          else if (columnData.field === "discountprice") {
            columnNames.push({
              field: "editedtotal",
              headerName: "OFFER TOTAL",
              headerAlign: "center",
              align: "center",
              width: 124,
              renderCell: (params) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: '10px' }}>{Utility.ConvertNumberWithSpecifiedDigits(parseFloat(params.row.editedtotal))}</span>
                  {params.colDef.editable && <EditIcon style={{ marginLeft: 10, marginBottom: 3, fontSize: '1rem', marginRight: -16 }} />}
                </div>
              ),
              editable: !notPermitted,
              cellClassName: (params) => 'lavenderCell',
            },
              {
                field: "addlesspercent",
                headerName: "ADD/LESS",
                headerAlign: "center",
                align: "center",
                width: 90,
                renderCell: renderCellExpand,
                editable: false,
              })
          }
        }
      });
      setColumnNames(columnNames);
    }

    UtilityProxy.getDate((response) => {
      if (response) {
        setDate(response.errorMessage);
      }
    });
  };

  const prepareStoneData = () => {
    let selectedStoneDetails = [];
    listData.map((iRow) => {
      let obj = {
        stoneid: iRow.stoneid,
        size: iRow.size,
        offerdiscount: Number(iRow.editeddiscount),
        offerppc: Number(iRow.editedprice),
        offertotal: Number((parseFloat(iRow.editedtotal)).toFixed(2)),
        rapnetprice: Number(iRow.originalprice),
      };
      selectedStoneDetails.push(obj);
      return true;
    });

    return selectedStoneDetails;
  };

  let prepareData = () => {
    return {
      userid: Constants.loggedInUser.id,
      customerid: customer.value,
      brokerid: broker && broker.brokerid ? broker.brokerid : -1,
      remark: remark,
      days: days,
      daysloss: daysloss,
      commission: brokerCommissionPercent,
      brokerage: brokerCommission,
      size: totalCarat,
      discount: totalDiscount,
      ppc: avgPricePerCarats,
      total: invoiceAmount,
      finalamount: payableAmount,
      addlessamount: addLessAmount,
      addlesspercent: addLessPercent,
      stones: prepareStoneData(),
    };
  };

  const saveOffer = () => {
    let data = prepareData();
    if (handleOffer) {
      if (handleValidation) {
        if (handleValidation(data)) {
          handleOffer(data);
        } else {
          setShowError(true);
        }
      }
    }
  };

  const applyValueToAllFields = () => {
    if (!applyValue || !applyToAll) return;

    let totalInvoice = 0;
    let bChanged = false;
    let updatedListData = [];

    updatedListData = listData.map((row) => {
      let newRow = row;
      if (applyToAll.label === "Discount") {
        let value = Number((parseFloat(row.olddiscount) + parseFloat(applyValue)).toFixed(2));

        if (parseFloat(value) !== parseFloat(row.editeddiscount)) {
          bChanged = true;
          let ppc = Number((row.originalprice * (1 + value / 100)).toFixed(2));
          newRow = {
            ...row,
            editeddiscount: value,
            editedprice: ppc,
            editedtotal: Number((ppc * row.size).toFixed(2)),
          };
        }
      } else if (applyToAll.label === "PPC") {
        let value = Number((parseFloat(row.oldppc) + parseFloat(applyValue)).toFixed(2));
        if (parseFloat(value) !== parseFloat(row.editedprice)) {
          bChanged = true;
          let tdiscount = Number(((((row.originalprice - value) / row.originalprice) * 100) * -1).toFixed(2));
          newRow = {
            ...row,
            editedprice: value,
            editeddiscount: tdiscount,
            editedtotal: parseFloat(Number((value * row.size).toFixed(2))),
          };
        }
      } else if (applyToAll.label === "Total") {
        let value = Number((parseFloat(row.olddiscountprice) + parseFloat(applyValue)).toFixed(2));

        if (parseFloat(value) !== parseFloat(row.editedtotal)) {
          bChanged = true;
          let ppc = Number((value / row.size).toFixed(2));
          newRow = {
            ...row,
            editedtotal: value,
            editedprice: ppc,
            editeddiscount: Number(((((row.originalprice - ppc) / row.originalprice) * 100) * -1).toFixed(2)),
          };
        }
      }

      return newRow;
    });

    setListData(updatedListData);

    if (!bChanged) return;

    if (applyToAll.label === "Discount") {
      updatedListData.map((row) => {
        let actualPrice = row.originalprice * row.size;
        totalInvoice += Number(actualPrice * ((100 + Number(row.editeddiscount)) / 100));
        return true;
      });
    } else {
      updatedListData.map((row) => {
        totalInvoice += Number(row.editedtotal);
        return true;
      });
    }

    setInvoiceAmount(totalInvoice.toFixed(2));
    setPayableAmount(Number(totalInvoice.toFixed(2)));
    setTotalDiscount(
      Number(100 - (totalInvoice * 100) / actualAmount).toFixed(2) * -1
    );
    setAvgPricePerCarats((totalInvoice / totalCarat).toFixed(2));
    setNewTotalDiscount(
      ((100 - (totalInvoice * 100) / actualAmount) * -1).toFixed(2)
    );
    setNewTotalPPC((totalInvoice / totalCarat).toFixed(2));
    setNewTotalInvoiceAmount(totalInvoice.toFixed(2));

    addLessPercentCalc(addLessPercent, updatedListData);
  };

  const closeErrorDialog = () => {
    setShowError(false);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleStoneDetailModal = (params) => {
    setStoneDetailModalId(params.value);
    setShowStoneDetailModal(true);
  };

  const columnsData = {
    "5dd43313-18b9-41a5-9e07-09d61ad6863c": {
      field: "stoneid",
      headerName: "STONEID",
      headerAlign: "center",
      width: 80,
      align: "center",
      renderCell: (params) => Utility.NeedToShowStoneDetailModal() ?
        <Button
          sx={{ textDecorationLine: "underline", color: 'black', }}
          onClick={() => handleStoneDetailModal(params)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
    },
    "62c37a29-d2ff-4c72-8cb3-07e52a83d484": {
      field: "status",
      headerName: "STATUS",
      headerAlign: "center",
      align: "center",
      width: 100,
    },
    "eb5db767-47d2-4444-9b52-7dc35c853fc7": {
      field: "shape",
      headerName: "SHAPE",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
    },
    "9f0b7352-8ca1-459d-944c-eb46dad5aed1": {
      field: "size",
      headerName: "SIZE",
      headerAlign: "center",
      align: "center",
      width: 40,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.size)
    },
    "fe7c00f1-774a-45a2-aec0-e5fb2ea1101e": {
      field: "color",
      headerName: "COLOR",
      headerAlign: "center",
      align: "center",
      width: 65,
      renderCell: renderCellExpand,
    },
    "1035d1d0-bc7c-404f-8f58-c80bea2de613": {
      field: "clarity",
      headerName: "CLARITY",
      headerAlign: "center",
      align: "center",
      width: 75,
      renderCell: renderCellExpand,
    },
    "3597803f-8932-40c6-8de6-81006f4d6d5b": {
      field: "cut",
      headerName: "CUT",
      headerAlign: "center",
      align: "center",
      width: 50,
      renderCell: renderCellExpand,
    },
    "859c71c9-c9c8-4f2c-9eb7-08e388e505ad": {
      field: "pol",
      headerName: "POL",
      headerAlign: "center",
      align: "center",
      width: 40,
      renderCell: renderCellExpand,
    },
    "5541c182-21b8-496e-b342-b0b89f3d302f": {
      field: "sym",
      headerName: "SYM",
      headerAlign: "center",
      align: "center",
      width: 40,
      renderCell: renderCellExpand,
    },
    "8296e627-0be5-4a66-830f-ea6867cea137": {
      field: "flo",
      headerName: "FLO",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: renderCellExpand,
    },
    "6defca68-d5d9-4c30-ae83-938a01f45a07": {
      field: "colortype",
      headerName: "COL TYPE",
      headerAlign: "center",
      align: "center",
      width: 80,
      editable: notPermitted,
    },
    "53c8a138-3f8e-486c-a9ba-f5c671065ad7": {
      field: "originalprice",
      headerName: "RAP",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.originalprice)
    },
    "798a8663-0f0c-41be-8512-16dd60d5f25e": {
      field: "discount",
      headerName: "DIS",
      headerAlign: "center",
      align: "center",
      width: 70,
      editable: notPermitted,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.discount),
      cellClassName: (params) => 'bold-cell',
    },
    "39c634f1-2644-4307-acbb-983b4de4229e": {
      field: "discountpricepercarat",
      headerName: "PPC",
      headerAlign: "center",
      align: "center",
      width: 120,
      valueGetter: (params) =>
        (Number(params.row.discountprice) / Number(params.row.size)).toFixed(2),
      cellClassName: (params) => 'bold-cell',
    },
    "7df28e0e-0303-4ff8-a432-9dedb384afa8": {
      field: "discountprice",
      headerName: "TOTAL",
      headerAlign: "center",
      align: "center",
      width: 120,
      editable: notPermitted,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(parseFloat(params.row.discountprice)),
      cellClassName: (params) => 'bold-cell',
    },
  };

  const handleProcessRowUpdateError = (error) => {
    // console.error(error);
  };

  const processRowUpdate = (newR, oldRow) => {
    const changedFeilds = Utility.getChangedFields(newR, oldRow);
    if (changedFeilds.length > 0) {
      const { id, field, value } = changedFeilds[0];
      let totalInvoice = 0;

      let bChanged = false;
      let buttonDisable = false;
      let newRow = oldRow;
      if (((value > 1000 || value < -100) && field === "editeddiscount") || (value <= 0 && (field === "editedtotal" || field === "editedprice"))) {
        buttonDisable = true;
      }
      const updatedListData = listData.map(row => {
        if (buttonDisable === false && row.stoneid !== id && (row.editeddiscount > 1000 || row.editeddiscount < -100 || row.editedtotal <= 0)) {
          buttonDisable = true;
        }

        if (row.stoneid === id) {
          if (field === "editeddiscount" && parseFloat(value) !== parseFloat(row.editeddiscount)) {
            bChanged = true;
            let ppc = Number(
              (row.originalprice * ((1 + (Number(value)) / 100))).toFixed(2));
            newRow = {
              ...row,
              [field]: Number(value),
              editedprice: ppc,
              editedtotal: Number((ppc * row.size).toFixed(2)),
            };
          }
          else if (field === "editedprice" && parseFloat(value) !== parseFloat(row.editedprice)) {
            bChanged = true;
            let tdiscount = Number(((((row.originalprice - (Number(value))) / row.originalprice) * 100) * (-1)).toFixed(2));
            newRow = {
              ...row,
              [field]: Number(value),
              editeddiscount: tdiscount,
              editedtotal: parseFloat((Number(value) * row.size).toFixed(2)),
            };
          }
          else if (field === "editedtotal" && parseFloat(value) !== parseFloat(row.editedtotal)) {
            bChanged = true;
            let ppc = Number((Number(value) / row.size).toFixed(2));
            newRow = {
              ...row,
              [field]: Number(value),
              editeddiscount: Number(((((row.originalprice - (ppc)) / row.originalprice) * 100) * (-1)).toFixed(2)),
              editedtotal: Number((ppc * row.size).toFixed(2)),
              editedprice: Number(ppc),
            };
          }
          return newRow;
        }
        return row;
      });
      setListData(updatedListData);
      setOfferButtonDisable(buttonDisable);

      if (!bChanged) return oldRow;

      if (field === "editeddiscount") {
        updatedListData.map((row) => {
          let actualPrice = row.originalprice * row.size;
          totalInvoice += Number(
            actualPrice * ((100 + Number(row.editeddiscount)) / 100)
          );
          return true;
        });
        setInvoiceAmount(totalInvoice.toFixed(2));
        setPayableAmount(Number(totalInvoice.toFixed(2)));
        setTotalDiscount(
          Number(
            100 - Number(totalInvoice * 100) / Number(actualAmount)
          ).toFixed(2) * -1
        );
        setAvgPricePerCarats((totalInvoice / totalCarat).toFixed(2));
        setNewTotalDiscount(((100 - Number(totalInvoice * 100) / Number(actualAmount)
        ) * -1).toFixed(2));
        setNewTotalPPC((totalInvoice / totalCarat).toFixed(2));
        setNewTotalInvoiceAmount(totalInvoice.toFixed(2));
      }
      else {
        updatedListData.map((row) => {
          totalInvoice += Number(row.editedtotal);
          return true;
        });
        setInvoiceAmount(Number(totalInvoice).toFixed(2));
        setPayableAmount(Number(totalInvoice).toFixed(2));
        setTotalDiscount(
          Number(
            100 - Number(totalInvoice * 100) / Number(actualAmount)
          ).toFixed(2) * -1
        );
        setAvgPricePerCarats((totalInvoice / totalCarat).toFixed(2));
        setNewTotalDiscount(((100 - Number(totalInvoice * 100) / Number(actualAmount)
        ) * -1).toFixed(2));
        setNewTotalPPC((totalInvoice / totalCarat).toFixed(2));
        setNewTotalInvoiceAmount(totalInvoice.toFixed(2));
      }
      return newRow;
    } else {
      // No changes detected, return the newRow to trigger exit edit mode
      return { ...newR };
    }
  };

  const handleDiscount = (event) => {

    if ((event.key === 'Enter' || event.type === 'blur') && event.target.value !== newTotalDiscount) {

      (parseFloat(event.target.value) < -100 || parseFloat(event.target.value) >= 1000) ? setOfferButtonDisable(true) : setOfferButtonDisable(false)

      let newDiscount = event.target.value;

      let newInvoiceAmount = 0;
      let actualPrice = 0;
      listData.map((iList) => {
        let iActualPrice = parseFloat(iList.size * iList.originalprice);
        actualPrice += iActualPrice;
        return true;
      });

      newInvoiceAmount = actualPrice + (actualPrice * (parseFloat(newDiscount) / 100));
      handleInvoicee({
        key: 'Enter', // Example key
        type: 'blur', // Example type
        target: { value: parseFloat(newInvoiceAmount.toFixed(2)) },
        message: "discount"
      });
    }
  };

  const handleInvoicee = (event) => {

    if ((event.key === 'Enter' || event.type === 'blur') && event.target.value !== newTotalInvoiceAmount) {

      parseFloat(event.target.value) <= 0 ? setOfferButtonDisable(true) : setOfferButtonDisable(false)

      if (event.target.value < 0) return;

      let newInvoiceAmount = event.target.value;
      let newList = [];
      let lActualPrice = 0;
      let lInvoiceAmount = 0;
      let lastIndex = listData.length - 1;
      listData.map((iList, index) => {

        let tdiscount = parseFloat((newInvoiceAmount / oldInvoiceAmount).toFixed(5));
        let iDiscountPrice = parseFloat((tdiscount * parseFloat(iList.olddiscountprice)).toFixed(2));
        if (index === lastIndex) iDiscountPrice = parseFloat((newInvoiceAmount - lInvoiceAmount).toFixed(2));
        let iActualPrice = parseFloat((iList.originalprice * iList.size).toFixed(2));

        let listOp = {
          ...iList,
          editeddiscount: parseFloat((((iActualPrice - iDiscountPrice) / iActualPrice) * 100).toFixed(2)) * -1,
          editedtotal: Number(iDiscountPrice),
          editedprice: Number(iDiscountPrice / iList.size),
        };

        newList.push(listOp);
        lActualPrice += iActualPrice;
        lInvoiceAmount += Number(iDiscountPrice);
        return newList;
      });
      setListData(newList);
      setTotalDiscount(
        Number(100 - (lInvoiceAmount * 100) / lActualPrice).toFixed(2) * -1
      );
      setInvoiceAmount(event.message === "PPC" ? lInvoiceAmount.toFixed(2) : newInvoiceAmount);
      setNewTotalInvoiceAmount(event.message === "PPC" ? lInvoiceAmount.toFixed(2) : parseFloat(newInvoiceAmount).toFixed(2));
      setNewTotalDiscount(((100 - (lInvoiceAmount * 100) / lActualPrice) * -1).toFixed(2));
      setNewTotalPPC((lInvoiceAmount / totalCarat).toFixed(2));
      setAvgPricePerCarats(parseFloat((lInvoiceAmount / totalCarat).toFixed(2)))
    }
  };

  const handleAddLessPercent = (event) => {
    if ((event.key === 'Enter' || event.type === 'blur') && event.target.value !== oldAddLessPercent) {
      addLessPercentCalc(event.target.value, listData);
    }
  };

  const addLessPercentCalc = (value, data) => {

    let newList = [];
    let addLessAmount = 0;
    let addLessPercent = value;
    let newInvoiceAmount = parseFloat(invoiceAmount);
    let daysLoss = 0;
    data.map((iList, index) => {
      addLessAmount += iList.editedtotal * (addLessPercent / 100);
      let listOp = {
        ...iList,
        addlesspercent: parseFloat(addLessPercent).toFixed(2),
      };
      newList.push(listOp);
      return newList;
    });
    newInvoiceAmount = newInvoiceAmount + Number(addLessAmount);
    if (daysloss) {
      let lossPercentage = Number((oldDays / 30).toFixed(2));
      daysLoss = Number((newInvoiceAmount * (lossPercentage / 100)).toFixed(2));
      setDaysloss(daysLoss);
    }
    setListData(newList);
    setOldAddLessPercent(addLessPercent);
    setAddLessAmount(parseFloat(addLessAmount).toFixed(2));
  }

  const handleAddLessAmount = (event) => {
    if ((event.key === 'Enter' || event.type === 'blur') && event.target.value !== oldAddLessAmount) {
      let newList = [];
      let newInvoiceAmount = parseFloat(invoiceAmount);
      let daysLoss = 0;
      let addLessAmount = event.target.value;
      let addLessPercent = ((addLessAmount / invoiceAmount) * 100);
      listData.map((iList, index) => {
        // addLessAmount += iList.discountprice * (addLessPercent / 100);
        let listOp = {
          ...iList,
          addlesspercent: parseFloat(addLessPercent).toFixed(2),
        };

        newList.push(listOp);
        return newList;
      });
      newInvoiceAmount = newInvoiceAmount + Number(addLessAmount);
      if (daysloss) {
        let lossPercentage = Number((oldDays / 30).toFixed(2));
        daysLoss = Number((newInvoiceAmount * (lossPercentage / 100)).toFixed(2));
        setDaysloss(daysLoss);
      }

      setListData(newList);
      setOldAddLessAmount(addLessAmount);
      setAddLessPercent(parseFloat(addLessPercent).toFixed(2));
    }
  };

  const handlePricePerCarat = (event) => {

    if ((event.key === 'Enter' || event.type === 'blur') && event.target.value !== newTotalPPC) {

      parseFloat(event.target.value) <= 0 ? setOfferButtonDisable(true) : setOfferButtonDisable(false)

      if (event.target.value < 0) return;

      let newPricePerCarat = event.target.value;
      setInvoiceAmount((totalCarat * newPricePerCarat).toFixed(2));

      handleInvoicee({
        key: 'Enter', // Example key
        type: 'blur', // Example type
        target: { value: parseFloat((totalCarat * newPricePerCarat).toFixed(2)) },
        message: "PPC", // Example target with value
      });

      setAvgPricePerCarats(newPricePerCarat);
      setNewTotalPPC(parseFloat(newPricePerCarat).toFixed(2));
    }
  };

  const rows = listData;
  //MARK: Custom Tool Bar
  function CustomToolbar() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          alignItems: "center",
          marginHorizontal: "5px",
          "&.MuiDataGrid-toolbarContainer": {
            padding: "2px 4px !important",
          },
        }}
      >
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <Box sx={{ flexGrow: 1, display: { sm: "none", lg: "block" } }} />

        {/* Custom Buttons */}



        {stonesLoader ? (
          <CircularProgress size="1.4rem" />
        ) : (
          <Tooltip title="Reload List">
            <RefreshOutlinedIcon
              onClick={() => {
                handleSearch(stoneId);
                setOfferButtonDisable(false);
              }}
              color="primary"
              fontSize="large"
              sx={{
                cursor: "pointer",
                height: "1.8rem",
                width: "1.8rem",
              }}
            />
          </Tooltip>
        )}
        <GridToolbarQuickFilter debounceMs={500} />
      </GridToolbarContainer>
    );
  }

  return (
    <div>
      <div>
      {showStoneDetailModal ? (
        <StoneDetailModal
          show={showStoneDetailModal}
          stoneId={stoneDetailModalId}
          handleClose={() => setShowStoneDetailModal(false)}
        />
      ) : null}

      <CommonSnackbar
        show={showError}
        message={
          <Box>
            stones validation Failed
            <br /> Please enter correct data
          </Box>
        }
        variant={"error"}
        autoHide={false}
        handleClose={closeErrorDialog}
        title="Validation Failure"
      />

        {showUserDetailModal ? (
          <Box
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(1px)",
              zIndex: 1299,
            }}>
            <UserDetailModal
              show={true}
              handleClose={() => setShowUserDetailModal(false)}
              handleSelect={(selectedOption) => {
                const selectedCustomers = brokerOptions.filter(opt =>
                  selectedOption.includes(opt.value)
                );
                setBroker(selectedCustomers[0]);
                setShowUserDetailModal(false)
              }}
              userids={brokerOptions.filter(option => option.value !== -1).map(cust => cust.value)}
              selectedIds={broker ? [broker.value] : []}
              usertype={"B"}
              loading={showUserDetailModal}
              isMulti={false}
            />
          </Box>
        ) : null}

      </div>


      <Modal backdrop="static" show={show} onHide={handleClose} dialogClassName="bhb" enforceFocus={false}>


        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;
            Offer
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Box>
            <Box
              display={"grid"}
              gridTemplateColumns={"1fr 1fr 1fr"}
              width={"100%"}
              height={"100%"}
              gap="15px"
            >
              <Box display={"flex"} flexDirection={"column"}>
                <Box sx={{ display: "flex", width: "100%", gap: "15px" }}>
                  <Typography sx={{ width: "80px" }}>Customer</Typography>
                  <Typography sx={{ fontWeight: "bold" }}>
                    {customer.value + " | " + customer.label}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", width: "100%", mt: 1, gap: "15px", alignItems: "center" }}>
                  <Typography sx={{ width: "80px" }}>Broker</Typography>
                  {Constants.loggedInUser.usertype !== "B" ? (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "10px",
                        width: "60%",
                        alignItems: "center",
                      }}
                    >
                      <Box sx={{ flexGrow: 1 }}>
                        <Select menuPlacement="auto"
                          blurInputOnSelect={false}
                          menuPortalTarget={document.body}
                          styles={{
                            ...Constants.Styles,
                            control: (base) => ({
                              ...base,
                              width: '20rem',
                              minHeight: "38px"
                            }),
                          }}
                          getOptionLabel={(option) => option.label}
                          getOptionValue={(option) => option.value}
                          options={brokerOptions}
                          value={broker === null ? { value: -1, label: " - " } : { value: broker.brokerid, label: broker.label }}
                          isClearable
                          onChange={(e) => setBroker(e)}
                        />
                      </Box>
                      <Tooltip title="View More Data">
                        <span style={{ cursor: "pointer", marginLeft: "8px" }}>
                          <OpenInNewIcon
                            style={{ fontSize: "20px", marginBottom: "3px" }}
                            onClick={() => setShowUserDetailModal(true)}
                            color="action"
                          />
                        </span>
                      </Tooltip>
                    </Box>
                  ) : (
                    <Typography sx={{ fontWeight: "bold" }}>
                      {broker.label}
                    </Typography>
                  )}
                </Box>
                <Box sx={{ display: "flex", width: "100%", mt: 1, gap: "15px" }}>
                  <Typography sx={{ width: "80px" }}>User</Typography>
                  <Typography sx={{ fontWeight: "bold" }}>{user}</Typography>
                </Box>
              </Box>
              <Box>
              </Box>
              <Box display={"flex"} gap="15px" flexDirection={"column"}>
                <Box
                  width={"100%"}
                  display={"flex"}
                  gap="15px"
                  alignItems={"center"}
                  sx={{
                    "& .MuiOutlinedInput-input": {
                      height: "0.5rem",
                    },
                    "& .MuiTextField-root": {
                      marginTop: 0,
                      marginBottom: 0
                    }
                  }}
                >
                  <Typography sx={{ width: "50px" }}>Date</Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TextField
                      margin="normal"
                      fullWidth
                      label="Date"
                      disabled
                      value={date}
                    />
                  </LocalizationProvider>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                width: "100%",
                position: "relative",
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  fontSize: Constants.defaultTableFontSize,
                  fontWeight: Constants.defaultFontWeight,
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "8px",
                  fontSize: Constants.defaultTableFontSize,
                  fontWeight: Constants.defaultFontWeight,
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "15px",
                  fontSize: Constants.defaultTableFontSize,
                  fontWeight: Constants.defaultFontWeight,
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "22px",
                  fontSize: Constants.defaultTableFontSize,
                  fontWeight: Constants.defaultFontWeight,
                },

                "& .MuiTablePagination-selectLabel": {
                  marginTop: "15px",
                },
                "& .MuiTablePagination-displayedRows": {
                  marginTop: "15px",
                },
                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                  fontWeight: Constants.defaultFontWeight,
                },
                "& .css-cc8tf1": {
                  fontWeight: Constants.defaultFontWeight,
                },
                "& .lavenderCell": {
                  color: "#080808",
                  backgroundColor: "#D8BFD8",
                },
                "& .bold-cell": {
                  fontWeight: "800",
                },
                mt: 2,
              }}
            >
              <Box style={{ display: "flex", width: "100%", gap: "15px" , alignItems:'center', flexDirection: 'row', justifyContent: 'flex-end', padding: "5px",}}>
  
  <Typography sx={{ fontSize: "13px", fontWeight: 600, }}>
    Discount / PPC
  </Typography>
<TextField
  fullWidth
  sx={{
    width: "130px",
    "& .MuiInputBase-root": {
      height: "33px",
    },
    "& .MuiInputBase-input": {
      padding: "6px 8px",
      fontSize: "14px",
    },
  }}
  value={applyValue}
  onChange={(e) => setApplyValue(e.target.value)}
  className="apply-value"
/>
<Box
  sx={{
    width: "120px",
  }}
>
  <Select
    menuPlacement="auto"
    blurInputOnSelect={false}
    className="basic-single"
    classNamePrefix="select"
    value={applyToAll}
    isSearchable={true}
    menuPortalTarget={document.body}
    styles={{
      ...Constants.Styles,
      control: (base, state) => ({
        ...base,
        height: 33,
        minHeight: 33,
        fontSize: 14,
      }),
      indicatorsContainer: (base) => ({
        ...base,
        height: 33,
      }),
      valueContainer: (base) => ({
        ...base,
        height: 33,
        padding: "0 8px",
      }),
    }}
    options={applyToAllOption}
    onChange={(selectedOption) => setApplyToAll(selectedOption)}
  />
</Box>

<LoadingButton
  variant="contained"
  onClick={ applyValueToAllFields}
  type="Submit"
  color="success"
  startIcon={<CheckIcon />}
  sx={{
    width: "105px",
    height: "33px",
    fontSize: "14px",
    padding: "6px 16px",
  }}
>
  Apply
</LoadingButton>

              </Box>
              <DataGridPro
                disableRowSelectionOnClick={true}
                autoHeight
                slots={{ toolbar: CustomToolbar }}
                rows={rows}
                columns={columnNames}
                processRowUpdate={processRowUpdate}
                onProcessRowUpdateError={handleProcessRowUpdateError}
                getRowId={(row) => row.stoneid}
                density="compact"
                sx={{ fontSize: Constants.defaultTableFontSize, fontWeight: 'bold' }}
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      // Hide columns id, the other columns will remain visible
                      locationid: false,
                    },
                  },
                  sorting: {
                    sortModel: [{ field: "stoneid", sort: "asc" }],
                  },
                  pagination: {
                    paginationModel: Constants.pageSize,
                  },
                }}
                pageSizeOptions={Constants.pageSizeOptions}
                pagination
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                apiRef={apiRef}
                onCellClick={handleCellClick}
                editMode="cell"
              />
            </Box>
            <Box
              display={"grid"}
              gridTemplateColumns={"0.5fr 0.6fr 1fr"}
              width={"100%"}
              height={"100%"}
              gap={"15px"}
            >
              <Box display={"flex"} flexDirection={"column"}>
                <Box sx={{ display: "flex", width: "100%" }}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label="Pieces"
                    disabled
                    value={listData.length}
                  />
                </Box>
                <Box sx={{ display: "flex", width: "100%" }}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label="Carats"
                    disabled
                    value={totalCarat}
                  />
                </Box>
              </Box>
              <Box display={"flex"} flexDirection={"column"}>

                <Box sx={{ display: "flex", width: "100%" }}>
                  <TextField
                    margin="normal"
                    // type="number"
                    fullWidth
                    label="Discount"
                    placeholder="Enter Discount"
                    value={totalDiscount}
                    onChange={(e) => setTotalDiscount(e.target.value)}
                    onKeyDown={handleDiscount}
                    onBlur={handleDiscount}
                    disabled={notPermitted}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {!notPermitted && (
                            <EditIcon style={{ fontSize: '1.1rem', color: 'black', marginBottom: 4, marginRight: -3 }} />
                          )}
                        </InputAdornment>
                      )
                    }}
                  />
                </Box>
                <Box sx={{ display: "flex", width: "100%", gap: "15px" }}>
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label="Price Per Carat Amount"
                    placeholder="Enter Price Per Carat Amount"
                    value={avgPricePerCarats}
                    onChange={(e) => setAvgPricePerCarats(e.target.value)}
                    onKeyDown={handlePricePerCarat}
                    onBlur={handlePricePerCarat}
                    disabled={notPermitted}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {!notPermitted && (
                            <EditIcon style={{ fontSize: '1.1rem', color: 'black', marginBottom: 4, marginRight: -3 }} />
                          )}
                        </InputAdornment>
                      )
                    }}
                  />
                  <Box sx={{ display: "flex" }}>
                    <TextField
                      margin="normal"
                      type="number"
                      fullWidth
                      label="Days"
                      placeholder="Enter Days"
                      value={days}
                      sx={{ visibility: Constants.loggedInUser.usertype !== "E" ? "hidden" : "visible" }}
                      onKeyDown={(e) => {
                        if (e.key === "+" || e.key === "-") {
                          e.preventDefault(); // Prevent typing + or -
                        }
                        if (e.key === "Enter" || e.type === "blur")
                          setOldDays(e.target.value > 0 ? e.target.value : 0);
                      }}
                      onChange={(e) => setDays(e.target.value > 0 ? e.target.value : 0)}
                      onBlur={(e) => {
                        if (e.key === "Enter" || e.type === "blur")
                          setOldDays(e.target.value > 0 ? e.target.value : 0);
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {!notPermitted && (
                              <EditIcon style={{ fontSize: '1.1rem', color: 'black', marginBottom: 4, marginRight: -3 }} />
                            )}
                          </InputAdornment>
                        )
                      }}
                    />
                  </Box>
                </Box>
              </Box>
              <Box display={"flex"} flexDirection={"column"}>
                <Box sx={{ display: "flex", width: "100%", gap: "15px" }}>
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label="Invoice Amount"
                    placeholder="Enter invoice amount"
                    value={invoiceAmount}
                    onChange={(e) => setInvoiceAmount(e.target.value)}
                    onKeyDown={handleInvoicee}
                    onBlur={handleInvoicee}
                    disabled={notPermitted}
                    sx={{ width: "40%" }} // ⬅️ wider
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {!notPermitted && (
                            <EditIcon style={{ fontSize: '1.1rem', color: 'black', marginBottom: 4, marginRight: -3 }} />
                          )}
                        </InputAdornment>
                      )
                    }}
                  />
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label="Add/Less %"
                    placeholder="Enter Add/Less Discount"
                    value={addLessPercent}
                    onChange={(e) => setAddLessPercent(e.target.value)}
                    onKeyDown={handleAddLessPercent}
                    onBlur={handleAddLessPercent}
                    sx={{ width: "30%", visibility: Constants.loggedInUser.usertype !== "E" ? "hidden" : "visible" }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <EditIcon style={{ fontSize: '1.1rem', color: 'black', marginBottom: 4, marginRight: -3 }} />
                        </InputAdornment>
                      )
                    }}
                  />
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label="Add/Less Amount"
                    placeholder="Enter Add/Less Amount"
                    value={addLessAmount}
                    onChange={(e) => setAddLessAmount(e.target.value)}
                    onKeyDown={handleAddLessAmount}
                    onBlur={handleAddLessAmount}
                    sx={{ width: "30%", visibility: Constants.loggedInUser.usertype !== "E" ? "hidden" : "visible" }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <EditIcon style={{ fontSize: '1.1rem', color: 'black', marginBottom: 4, marginRight: -3 }} />
                        </InputAdornment>
                      )
                    }}
                  />
                  <Box sx={{ width: "40%", visibility: Constants.loggedInUser.usertype !== "E" ? "hidden" : "visible" }}>
                    <TextField
                      margin="normal"
                      type="number"
                      fullWidth
                      label={`Brokerage (${brokerCommissionPercent}%)`}
                      placeholder="Brokerage"
                      value={brokerCommission}
                      disabled
                    />
                  </Box>
                </Box>
                <Box display={"flex"} gap={"15px"}>
                  <Box sx={{ width: "50%", visibility: Constants.loggedInUser.usertype !== "E" ? "hidden" : "visible" }}>
                    <TextField
                      margin="normal"
                      type="number"
                      fullWidth
                      label="Days Loss"
                      placeholder="Days Loss"
                      value={daysloss}
                      disabled
                    />
                  </Box>
                  <Box sx={{ display: "flex", width: "50%", visibility: Constants.loggedInUser.usertype !== "E" ? "hidden" : "visible" }}>
                    <TextField
                      label={`Receive Amount `}
                      id="outlined-start-adornment"
                      margin="normal"
                      disabled
                      fullWidth
                      value={payableAmount}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {"$"}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box sx={{ display: "flex", width: "100%" }}>
              <TextField
                margin="normal"
                fullWidth
                multiline
                rows={1}
                label="Remark"
                placeholder="Enter Remark"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                disabled={notPermitted}
              />
            </Box>
          </Box>
        </Modal.Body>
        <Modal.Footer>
          {Utility.isAddAllowed(offer_Permission) ?
            (
              <Box>
                <LoadingButton
                  variant="contained"
                  onClick={saveOffer}
                  loading={loadingOfferButton}
                  loadingPosition="start"
                  type="Submit"
                  startIcon={<FaFileInvoice />}
                  sx={{ mr: 1 }}
                  disabled={offerButtonDisable}
                  color="success"
                >
                  Save
                </LoadingButton>
              </Box>
            ) : null}
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{ mr: 1 }}
            disabled={loadingOfferButton}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default OfferModal;